import {Stethoscope, Leaf, Heart, BookOpen, GraduationCap} from 'lucide-react';
export const jobListings = [
  {
    id: "pathology-lecturer",
    title: "Pathology Lecturer",
    type: "Remote",
    icon: <Stethoscope className="w-6 h-6" />,
    summary:
      "We are seeking a qualified Pathology Lecturer to join our team remotely. The successful candidate will be responsible for preparing and delivering online lectures, creating lesson plans, and assessing student performance.",
    requirements: [
      "Master's degree in Pathology or related field or equivalent",
      "Registration with relevant professional bodies",
      "At least 2 years of experience in teaching or research",
      "Strong online teaching and communication skills",
    ],
    responsibilities: [
      "Prepare and deliver online lectures",
      "Create lesson plans and implement them effectively online",
      "Assess student performance and provide feedback",
    ],
  },
  {
    id: "medical-lab-science",
    title: "Medical Laboratory Science Lecturer",
    type: "Remote",
    icon: <BookOpen className="w-6 h-6" />,
    summary:
      "We are seeking a qualified Medical Laboratory Science Lecturer to join our team remotely. The successful candidate will be responsible for teaching and mentoring students in medical laboratory science online.",
    requirements: [
      "Master's degree in Medical Laboratory Science or related field",
      "Registration with relevant professional bodies",
      "At least 2 years of experience in teaching or research",
      "Strong online teaching and communication skills",
    ],
    responsibilities: [
      "Teach and mentor students online",
      "Develop and implement online curriculum",
      "Assess student performance",
    ],
  },
  {
    id: "herbal-medicine",
    title: "Advanced Herbal Medicine Therapeutics Lecturer",
    type: "Remote / On-site",
    icon: <Leaf className="w-6 h-6" />,
    summary:
      "We are seeking a qualified Advanced Herbal Medicine Therapeutics Lecturer to join our team remotely. The successful candidate will be responsible for teaching and mentoring students in advanced herbal medicine therapeutics online.",
    requirements: [
      "PhD, Master's degree or at least BSc. in relevant field",
      "Certificate in advanced herbal medicine courses",
      "Experience in teaching or research",
      "Knowledge of traditional and modern herbal medicine practices",
      "Strong online teaching and communication skills",
      "Should be a brilliant practitioner of herbal medicine",
    ],
    responsibilities: [
      "Teach and mentor students online",
      "Develop and implement online curriculum",
      "Conduct research in herbal medicine",
    ],
  },
  {
    id: "physiotherapy",
    title: "Physiotherapy and Fitness Lecturer",
    type: "On-site - Ikorodu Lagos",
    icon: <Heart className="w-6 h-6" />,
    summary:
      "We are seeking a qualified Physiotherapy and Fitness Lecturer to join our team. The successful candidate will be responsible for teaching and mentoring students in physiotherapy and fitness online.",
    requirements: [
      "Master's degree in Physiotherapy or related field",
      "Registration with relevant professional bodies",
      "At least 2 years of experience in teaching or research",
      "Strong online teaching and communication skills",
    ],
    responsibilities: [
      "Teach and mentor students online",
      "Develop and implement online curriculum",
      "Assess student performance",
    ],
  },
  {
    id: "clinical-nutrition",
    title: "Integrative Clinical Nutrition Lecturer",
    type: "Remote",
    icon: <GraduationCap className="w-6 h-6" />,
    summary:
      "We are seeking a qualified Integrative Clinical Nutrition Lecturer to join our team remotely. The successful candidate will be responsible for teaching and mentoring students in integrative clinical nutrition online.",
    requirements: [
      "Master's degree in Nutrition or related field",
      "Should be a practitioner of Clinical Nutrition",
      "Experience in teaching or research",
      "Knowledge of integrative nutrition practices",
      "Strong online teaching and communication skills",
    ],
    responsibilities: [
      "Teach and mentor students online",
      "Develop and implement online curriculum",
      "Conduct research in integrative nutrition",
    ],
  },
];
